export enum COMPANY_TYPES {
  INSURANCE = "Insurance",
  RISK = "Risk",
  NO_COMPANY = "NoCompany",
  BROKER = "Broker"
}
